import React from "react";
import { DatePicker, Card } from "antd";
import moment from "moment";
// import DatePicker from "antd/es/date-picker"; // for js
import "antd/es/date-picker/style/css"; // for css
import "./index.css";
const { MonthPicker, RangePicker } = DatePicker;

const dateFormat = "MMMM DD, YYYY";
const monthFormat = "YYYY/MM";
const setDateFormat = "DD/MM/YYYY";

const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];

// function onChange(date, dateString) {
//   //console.log(date, dateString);
// }
const DateRangePicker = propsInfo => {
  const { startDate, endDate, changeRangePicker, analytic} = propsInfo;
  var onChange = (date, dateString) => { 
    var startDate = moment(dateString[0]).format();
    var endDate = moment(dateString[1]).format(); 
    changeRangePicker(startDate, endDate);
  };
  var isSameOrBefore = moment().subtract(1, "year")
  var isAfter = moment()
  return (
    <div id={analytic ?'rangePicker1':"rangePicker"}>
      <RangePicker
        className="gx-mb-3 gx-w-100"
        //   defaultValue={[
        //     moment(new Date(), dateFormat),
        //     moment(new Date(), dateFormat)
        //   ]}
        disabledDate={d => !d || d.isAfter(isAfter) || d.isSameOrBefore(isSameOrBefore)}
        format={dateFormat}
        onChange={onChange}
      />
    </div>
  );
};

export default DateRangePicker;
